import React from 'react'
import { compose } from 'recompose'
import ThemeProductCard from 'cms/CmsProductCard'
import withProductElement from '../../redux/product/withProductElement'
import { mergeArray } from 'cms/helpers/arrayHelpers'

const ProductCard = compose(
  withProductElement()
)(
  ({
    product,
    style,
    assets: {
      defaultImage,
      attributeRule,
    },
    router,
    settings,
    fetchStatus: {
      isRequest,
      isFailure,
    },
    renderElement,
    squareImage = true,
  }) => {
    return (
      renderElement(
        ThemeProductCard,
        {
          style,
          ...settings,
          attributeRule: mergeArray(
            'code',
            attributeRule,
            settings.attributeRule || [],
          ),
          loading: !product || isRequest || isFailure,
          product,
          router,
          defaultImage,
          squareImage,
        }
      )
    )
  }
)

ProductCard.propTypes = {}
ProductCard.defaultProps = {}

export default ProductCard



// WEBPACK FOOTER //
// ./src/components/Canvas/renderer/elements/productCard/ProductCard.js